import { useContext, useEffect } from 'react'
import { GlobalLoaderContext } from '../Context/GlobalLoader/GlobalLoader'
import { UserContext } from '../Context/User/UserContext'
import { CHECKING_IF_USER_IS_LOGGED_IN } from '../const/consts'
import { checkTokenReq } from '../service/User/api'
import { parseJwt } from '../helpers/http'
import { UserDtoToFrontAdapter } from '../helpers/adapters/user'
import { CookieService } from '../service/CookieStorageService'

export const useCheckToken = () => {
  const showLoader = useContext(GlobalLoaderContext)
  const userContext = useContext(UserContext)

  useEffect((): void => {
    // Check if user has a valid token
    if (CookieService.getItem()) {
      showLoader(true, CHECKING_IF_USER_IS_LOGGED_IN)
      checkTokenReq()
        .then((data) => {
          const { token, expirationDate } = data
          if (token) {
            CookieService.setItem(token, expirationDate)
            const { user } = parseJwt(token)
            userContext.updateUser(UserDtoToFrontAdapter(user))
          }
          showLoader(false)
        })
        .catch(() => {
          showLoader(false)
        })
    }
  }, [])
}
